import MaxWidth1200Layout from "@/components/Layout/MaxWidth1200Layout";
import Gray50Skeleton from "@/components/SkeletonLoader/Gray50Skeleton";
import { Box, SkeletonCircle } from "@chakra-ui/react";
// import dayjs from "dayjs";
import {
  Button,
  call,
  ColorIcon,
  colors,
  customEvent,
  HStack,
  Link,
  setVisitedFeature,
  Spacing,
  // TablePagination,
  // TopBanner,
  useResponsive,
  VLine,
  VStack,
} from "goi_common";

import { useEffect } from "react";
import { ReviewSmallCarousel } from "./components/ReviewSmallCarousel/ReviewSmallCarousel";
import { ReviewTagButtonChip } from "./components/ReviewTag/ReviewTagButtonChip";
// import { ReviewTagChip } from "./components/ReviewTag/ReviewTagChip";

import PrepaidBanners from "@/components/common/PrepaidBanners";
// import { StarScore } from "../MatchContainer/components/MatchRecommendations/StarScore";
import { SANGJO_REVIEW_TAGS } from "./constants/reviewTags";
import { useReviewListByTag } from "./hooks/useReviewListByTag";
import { useReviewPageRouter } from "./hooks/useReviewPageRouter";
import { ReviewCard } from "../MatcRecommendationContainer/components/MatchRecommendationParlorAndFacilitySection";
// import { bestGoiReviews } from "../MatcRecommendationContainer/constants/bestGoiReviews";
import { useInfiniteScroll } from "@/hooks/useInfiniteScroll";
import { useInifiniteDatas } from "@/hooks/useInfiniteDatas";
import { useRouter } from "next/router";

function ReviewContainer() {
  const {
    router,
    tag,
    page,
    // setReviewPageNum
  } = useReviewPageRouter();
  const pageNum = page ? Number(page) : 1;

  const {
    data: reviewsPages,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useReviewListByTag({ page: pageNum, tag });
  const { datas: reviews } = useInifiniteDatas(reviewsPages);

  const { setTarget: setReviewTarget } = useInfiniteScroll(fetchNextPage);

  useEffect(() => {
    setVisitedFeature("review");
  }, []);

  const { isBiggerThanMd } = useResponsive();

  return (
    <MaxWidth1200Layout>
      <VStack alignItems="center" padding={isBiggerThanMd ? "60px 0 40px" : "40px 0 30px"} gap={24}>
        <Box className={isBiggerThanMd ? "head_32_b" : "subtitle_21_b"}>
          <h2>고이 이용 후기</h2>
        </Box>

        <HStack gap={8}>
          <Button
            css={{
              padding: isBiggerThanMd ? "15px 20px" : "10px 12px",
              background: colors.orange650,
              color: colors.white,
              borderRadius: "5px",
            }}
            className="button_14_sb"
            onClick={() => {
              customEvent({
                newGtm: { path: "review", trigger_and_target: "rqst_btn-uv_mtch_rqst" },
              });
              router.push("/match/request/");
            }}
          >
            견적 받기
          </Button>
          <Button
            css={{
              padding: isBiggerThanMd ? "15px 20px" : "10px 12px",
              background: colors.gray900,
              color: colors.white,
              borderRadius: "5px",
            }}
            className="button_14_sb"
            onClick={() => {
              customEvent({
                newGtm: { path: "review", trigger_and_target: "call_btn-call" },
              });
              call("1666-9784");
            }}
          >
            전화 상담
          </Button>
        </HStack>
        <ReviewSmallCarousel
          event={{
            path: "review",
            trigger_and_target: "review_section_review_detail-uv_review_detail",
          }}
        />
      </VStack>
      <PrepaidBanners eventPath="review" isMobile />
      <ReviewFilter />

      {reviews ? (
        <VStack gap="12px">
          {reviews?.map((review) => (
            <ReviewCard
              key={review?.id}
              review={review}
              id={review?.id}
              currentTag={tag}
              event={{
                newGtm: { path: "review", trigger_and_target: "review-uv_review_detail" },
              }}
            />
          ))}
          {reviewsPages && hasNextPage && !isFetchingNextPage && (
            <div
              ref={setReviewTarget}
              css={{
                position: "absolute",
                bottom: "600px",
                width: "100%",
              }}
            />
          )}
        </VStack>
      ) : (
        <ReviewSkeleton />
      )}
      <Box
        css={{
          position: "fixed",
          bottom: "16px",
          left: "50%",
          transform: "translate(-50%, 0)",
        }}
      >
        <ReviewWriteButton />
      </Box>
    </MaxWidth1200Layout>
  );
}

const ReviewWriteButton = () => {
  const router = useRouter();

  const onClick = () => {
    router.push("/funeral/고이/review/post/");
  };
  return (
    <HStack
      gap="6px"
      css={{
        padding: "12px 24px",
        background: colors.gray900,
        color: colors.white,
        borderRadius: "30px",
        cursor: "pointer",
        alignItems: "center",
      }}
      onClick={onClick}
    >
      <ColorIcon name="icon_pencil_mono" color={colors.white} size="16px" />
      <Box className="button">장례후기 쓰기</Box>
    </HStack>
  );
};

export default ReviewContainer;

const ReviewFilter = () => {
  const { getReviewTagPageHref, tag: tagQueryParams } = useReviewPageRouter();

  return (
    <VStack padding="0px 24px 24px 24px">
      <h3 className="button_16_sb">비슷한 고민을 하셨던 상주님들의 후기를 살펴보세요</h3>
      <Spacing gap={15} />
      <HStack gap={6} maxWidth={"100%"} overflow="scroll">
        {["전체보기", ...SANGJO_REVIEW_TAGS].map((tagName) => {
          const isActived =
            tagName === tagQueryParams || (tagName === "전체보기" && !tagQueryParams);
          const href = getReviewTagPageHref(tagName === "전체보기" ? "" : tagName);

          return (
            <Link href={href} key={`filter_tag_${tagName}`}>
              <ReviewTagButtonChip tag={tagName} isActived={isActived} />
            </Link>
          );
        })}
      </HStack>
    </VStack>
  );
};

function ReviewSkeleton() {
  return (
    <VStack padding="0 24px">
      <Spacing gap={28} />
      <SkeletonCircle size="48px" startColor="#F5F5F5" endColor="#E9E9E9" />
      <Gray50Skeleton h="30px" w="100%" mt="18px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Spacing gap={28} />

      <VLine width="100%" height="1px" color={colors.gray100} />

      <Spacing gap={28} />
      <SkeletonCircle size="48px" startColor="#F5F5F5" endColor="#E9E9E9" />
      <Gray50Skeleton h="30px" w="100%" mt="18px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Spacing gap={28} />

      <VLine width="100%" height="1px" color={colors.gray100} />

      <Spacing gap={28} />
      <SkeletonCircle size="48px" startColor="#F5F5F5" endColor="#E9E9E9" />
      <Gray50Skeleton h="30px" w="100%" mt="18px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Spacing gap={28} />

      <VLine width="100%" height="1px" color={colors.gray100} />

      <Spacing gap={28} />
      <SkeletonCircle size="48px" startColor="#F5F5F5" endColor="#E9E9E9" />
      <Gray50Skeleton h="30px" w="100%" mt="18px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Spacing gap={28} />

      <VLine width="100%" height="1px" color={colors.gray100} />
    </VStack>
  );
}
